import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpM = createBreakpoint('m');
const mainCls = 'csaRange';
export const inputCls = `${mainCls}Input`;
export const sliderCls = `${mainCls}Slider`;

export default {
  [inputCls]: {
    display: 'flex',
    lineHeight: '40px',
    [brpM]: {
      lineHeight: '32px',
    },
    border: '1px solid #e4e4e4',
    '&.infocus': {
      borderColor: '#333f48',
    },
  },
  [`${inputCls}__half`]: {
    width: 'calc(50% - 6px)',
  },
  [`${inputCls}__half__disabled`]: {
    opacity: 0.4,
  },
  [`${inputCls}__input`]: {
    margin: 0,
    padding: 0,
    width: '100%',
    lineHeight: '40px',
    [brpM]: {
      lineHeight: '32px',
    },    
    border: '0 none',
    outline: 0,
  },
  [sliderCls]: {
    height: 30,
    '&.active': {
      '& .csaRangeSlider__track-1': {
        background: '#333f48',
      }
    }
  },
  [`${sliderCls}__disabled`]: {
    opacity: 0.4,
  },
  [`${sliderCls}__handle`]: {
    width: 30,
    height: 30,
    background: '#FFF',
    border: '1px solid rgba(0,0,0,.05)',
    borderRadius: '50%',
    boxShadow: '0 3px 1px 0 rgba(0,0,0,.1), 0 1px 1px 0 rgba(0,0,0,.16), 0 3px 8px 0 rgba(0,0,0,.15)',
    outline: 0,
    cursor: 'grab',
  },
  [`${sliderCls}__track`]: {
    position: 'absolute',
    top: 14,
    height: 4,
    background: '#333f48',
    borderRadius: 4,
    cursor: 'pointer',
  },
  [`${sliderCls}__track-0`]: {
    background: '#f1f1f1',
  },
  [`${sliderCls}__track-2`]: {
    background: '#f1f1f1',
  },
};
